import { HttpResponse } from '../../../model/http/http-client';

import ApiFactory from '../../../infraestruture/http/factories/ApiFactory';

import { CampaignListResponse, Campaign } from './dtos/response/CampaignListResponse';

export default class PublicService {
  httpClient = ApiFactory();


  public async getCampaigns(params?: {
    page: number;
    search?: string;
    categoryId?: number;
    signal?: AbortSignal;
  }): Promise<HttpResponse<CampaignListResponse | null>> {
    return await this.httpClient.request({
      method: 'get',
      url: '/financings',
      params: {
        page: params?.page,
        limit: 12,
        search: params?.search,
        categoryId: params?.categoryId,
      },

    });
  }

  public async getDetails(params?: { slug: string }): Promise<HttpResponse<Campaign | null>> {
    return await this.httpClient.request({
      method: 'get',
      url: `/financings/slug/${params?.slug}`,
    })

  }

  public async getCategories(): Promise<HttpResponse<any | null>> {
    return await this.httpClient.request({
      method: 'get',
      url: '/financing-categories/listing',
    });
  }

  public async getDetailsUserByUsername(data?: { username: string }): Promise<HttpResponse<any | null>> {
    return await this.httpClient.request({
      method: 'get',
      url: `/users/${data?.username}`,
    });
  }

  public async sendAnalytics(data?: { slug: string, ipAddress: string }): Promise<HttpResponse<any | null>> {
    return await this.httpClient.request({
      method: 'post',
      url: `financings/analytics`,
      body: {
        slug: data?.slug,
        ipAddress: data?.ipAddress,
      }
    });
  }
}
